// Mede a largura em px que um texto ocupa com uma fonte específica, usando um
// canvas fora da árvore (não força layout nem pinta nada na tela).
// Serve para calcular pisos de largura (ex.: "este badge nunca pode encolher
// abaixo de N caracteres") antes de o browser aplicar o text-overflow.

const DEFAULT_FONT_FAMILY = 'Roboto, Helvetica, Arial, sans-serif';

let context = null;
const cache = new Map();

const getContext = () => {
  if (context) return context;
  if (typeof document === "undefined") return null;
  context = document.createElement("canvas").getContext("2d");
  return context;
};

// 0.7rem só vira px depois de resolver o font-size da raiz (16px na maioria dos
// casos, mas o usuário pode ter aumentado a fonte do browser).
export const remToPx = (rem) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return rem * 16;
  }
  const root = parseFloat(
    window.getComputedStyle(document.documentElement).fontSize
  );
  return rem * (Number.isFinite(root) && root > 0 ? root : 16);
};

export const measureTextWidth = (
  text,
  {
    fontSize = 14,
    fontWeight = 400,
    fontFamily = DEFAULT_FONT_FAMILY,
    letterSpacing = 0,
  } = {}
) => {
  const value = String(text ?? "");
  if (!value) return 0;

  const font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  const key = `${font}|${letterSpacing}|${value}`;
  if (cache.has(key)) return cache.get(key);

  const ctx = getContext();
  let width;
  if (ctx) {
    ctx.font = font;
    // measureText ignora letter-spacing na maioria dos browsers; somamos na mão
    width = ctx.measureText(value).width + letterSpacing * value.length;
  } else {
    // sem DOM (SSR/testes) devolve uma estimativa grosseira em vez de quebrar
    width = value.length * fontSize * 0.6;
  }

  cache.set(key, width);
  return width;
};

export default measureTextWidth;
